import styled from 'styled-components';

export const Description = styled.p`
    font-size: 14px;
    font-weight: 400;
    color: #707a82;
`;
